import React, { useContext, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { AccessLevel, LawPortalFeature, UserContext } from '../../../../../Context/UserContext/UserContext';
import { Button, Grid, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { CompanyUnitSelectDialog } from './../../../../../Components';
import { EditLegalListWizard } from '../EditLegalListWizard';

const useStyles = makeStyles(() => ({
  topActionContainer: {
    marginBottom: '1rem',
    display: 'flex',
  },
}));
interface ICustomerLawListActionsProps {
  onDeleteComplete?: () => void;
}
export const CustomerLawListActions = ({ onDeleteComplete }: ICustomerLawListActionsProps) => {
  const { hasAccessToFeature, getCompanyUnitName } = useContext(UserContext);
  const canManage = hasAccessToFeature(LawPortalFeature.Manage, AccessLevel.Manage);
  const [updateDialogOpen, setUpdateDialogOpen] = useState<boolean>(false);
  const [editLegalListDialogOpen, setEditLegalListDialogOpen] = useState<boolean>(false);
  const { formatMessage } = useIntl();
  const classes = useStyles();

  const openMassUpdate = () => setUpdateDialogOpen(true);

  const closeMassUpdate = () => setUpdateDialogOpen(false);

  const openEditLegalList = () => {
    setEditLegalListDialogOpen(true);
  };

  const handleEditComplete = () => {
    if (onDeleteComplete) {
      onDeleteComplete();
    }
  };

  if (!canManage) {
    return null;
  }

  return (
    <>
      <Grid container justify="flex-end" className={classes.topActionContainer} spacing={1} direction="row">
        <Grid item>
          <Button onClick={openMassUpdate} variant="outlined">
            <FormattedMessage id="law-portal.manage.law-list.update-laws" />
          </Button>
          <CompanyUnitSelectDialog
            urlTemplate="/law-portal/our-laws/update-for-company-unit/{id}"
            title={formatMessage({ id: 'law-portal.manage.law-list.update-laws' })}
            selectPlaceholder={formatMessage(
              { id: 'law-portal.manage.update-laws.dialog.companyUnit.placeholder' },
              { alias: getCompanyUnitName(formatMessage, true) },
            )}
            open={updateDialogOpen}
            close={closeMassUpdate}
          />
        </Grid>
        <Grid item>
          <Button onClick={openEditLegalList} variant="outlined">
            <FormattedMessage id="law-portal.manage.legal-list.editLegalList" defaultMessage="EDIT LEGAL LIST" />
          </Button>
        </Grid>
      </Grid>
      <EditLegalListWizard
        open={editLegalListDialogOpen}
        onClose={() => setEditLegalListDialogOpen(false)}
        onComplete={handleEditComplete}
      />
    </>
  );
};
